<template>
	<v-layout row wrap>

		<financial-table-element
			xs="11"
			lighten="1"
			text="Suma kosztów programowych"
		></financial-table-element>

		<financial-table-element
			xs="1"
			lighten="1"
			:text="formatMoney(totalActions)"
		></financial-table-element>

	</v-layout>
</template>

<script>
	import {Numbers} from "@/utils/Numbers";
  import FinancialTableElement from "@/view/logged/offer/components/FinancialTableRowElement";

	export default {
		name: "SumOfActions",

    components: {FinancialTableElement},

    props: {
			totalActions: {},
		},

		mixins: [Numbers],
	};
</script>

<style scoped>

</style>